<template>
  <!-- Оболочка приложения на время bootstrap (проверка сессии + userData):
       рисуем только шапку-скелетон. Контент-силуэт отдаёт сама страница
       (own-скелетон роутера), чтобы на форме не мигали два разных каркаса.
       Раскладка 1:1 с Header.vue (container-xl, left/menu/right). -->
  <div class="app-skeleton">
    <!-- шапка -->
    <div class="as-header">
      <div class="container-xl d-flex align-items-center as-header__inner">
        <div class="as-header__left">
          <SkeletonBlock width="132px" height="28px" borderRadius="8px" />
          <span class="as-header__sep"></span>
          <SkeletonBlock width="24px" height="24px" borderRadius="8px" />
        </div>
        <div class="as-header__menu">
          <SkeletonBlock v-for="n in 4" :key="n" width="84px" height="20px" borderRadius="8px" />
        </div>
        <div class="as-header__right">
          <SkeletonBlock width="40px" height="40px" borderRadius="12px" />
          <SkeletonBlock width="192px" height="40px" borderRadius="8px" class="as-hide-sm" />
          <SkeletonBlock width="40px" height="40px" borderRadius="50%" />
          <SkeletonBlock width="40px" height="40px" borderRadius="12px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBlock from "@/components/service/SkeletonBlock";

export default {
  name: "AppSkeleton",
  components: { SkeletonBlock },
};
</script>

<style lang="scss" scoped>
.app-skeleton {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background-color: $color-background;
  overflow: hidden;
}
.as-header {
  height: 72px;
  background-color: $menu-bg;
}
.as-header__inner {
  height: 100%;
}
.as-header__left {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
}
.as-header__sep {
  width: 1px;
  height: 30px;
  background-color: $menu-base;
  opacity: 0.2;
}
.as-header__menu {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  @media (max-width: 975px) {
    display: none;
  }
}
.as-header__right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.as-hide-sm {
  @media (max-width: 767px) {
    display: none;
  }
}
</style>
